// import cv from "./CV.pdf";

export const socialLinks = [
	{ name: 'Instagram', link: 'https://www.instagram.com/satish_._.sharma/' },
	{ name: 'LinkedIn', link: 'https://www.linkedin.com/in/satishsh973/' },
	{ name: 'Github', link: 'https://github.com/satishTheLegend/' },
	// {name: "Resume", link: cv},
	{ name: 'Mail', link: 'mailto: satishsh973@gmail.com' },
];
